import { render } from "./Cardstep.vue?vue&type=template&id=3845de9c"
import script from "./Cardstep.vue?vue&type=script&lang=js"
export * from "./Cardstep.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/declic-center-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__